import { ReactNode, useId } from 'react';
import IconMinus from '../icons/IconMinus';
import IconPlus from '../icons/IconPlus';

function NumInput({
    label,
    description,
    subLabel,
    value,
    setValue,
    disabled = false,
}: {
    label: string;
    description: string;
    subLabel: ReactNode;
    value: number;
    setValue: (value: number) => void;
    disabled?: boolean;
}) {
    // Generate a unique ID for the input element
    const id = useId();
    return (
        <>
            <label className="fireknife-select-tickets__label" htmlFor={id}>
                <span className="fireknife-select-tickets__label-title">{label}</span>
                <span className="fireknife-select-tickets__label-info">{description}</span>
                <span className="fireknife-select-tickets__label-desc">{subLabel}</span>
            </label>
            <div className="fireknife-select-tickets__form-control-box">
                <input
                    className="fireknife-select-tickets__form-control"
                    id={id}
                    type="text"
                    inputMode="numeric"
                    value={value}
                    readOnly
                />
                <button
                    className="fireknife-select-tickets__form-control-step fireknife-select-tickets__form-control-step--dec fireknife-btn  fireknife-btn--sm fireknife-btn--primary"
                    type="button"
                    onClick={() => setValue(value - 1)}
                    disabled={disabled || value == 0}
                >
                    <IconMinus className="fireknife-select-tickets__form-control-step-icon" />
                </button>
                <button
                    className="fireknife-select-tickets__form-control-step fireknife-select-tickets__form-control-step--inc fireknife-btn fireknife-btn--sm fireknife-btn--primary"
                    type="button"
                    onClick={() => setValue(value + 1)}
                    disabled={disabled}
                >
                    <IconPlus className="fireknife-select-tickets__form-control-step-icon" />
                </button>
            </div>
        </>
    );
}

export default NumInput;
